import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-100 f f-center-center" }
const _hoisted_2 = { class: "f-row auth-layout__title t-dark mb-8" }
const _hoisted_3 = { class: "mb-4" }




export default /*#__PURE__*/_defineComponent({
  __name: 'AuthLayout',
  props: {
    title: String,
    icon: String,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_ButtonContainer = _resolveComponent("ButtonContainer")!
  const _component_HomeContainer = _resolveComponent("HomeContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HomeContainer, { class: "h-100 f f-center-center" }, {
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, [
          _createElementVNode("i", {
            class: _normalizeClass(`mr-2 auth-layout__icon fa-solid fa-${__props.icon}`)
          }, null, 2),
          _createElementVNode("span", null, _toDisplayString(__props.title), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ButtonContainer, null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ])
      ]),
      _: 3
    })
  ]))
}
}

})